<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="140px"
        :model="dataForm"
        :rules="editFormRules"
        :disabled="isDisabled"
      >
        <el-form-item label="培训主题：" prop="Title">
          <el-input
            placeholder="请输入培训主题"
            v-model="dataForm.Title"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="截止报名时间：" prop="DeadLine">
          <el-date-picker
            v-model="dataForm.DeadLine"
            type="datetime"
            value-format="timestamp"
            placeholder="选择时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="开始培训时间：" prop="StartTime">
          <el-date-picker
            v-model="dataForm.StartTime"
            type="datetime"
            value-format="timestamp"
            placeholder="选择时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="结束培训时间：" prop="EndTime">
          <el-date-picker
            v-model="dataForm.EndTime"
            type="datetime"
            value-format="timestamp"
            placeholder="选择时间"
          ></el-date-picker>
        </el-form-item> -->
        <el-form-item label="培训地址：" prop="Address">
          <el-input
            placeholder="请输入培训地址"
            v-model="dataForm.Address"
            clearable
            maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item label="报名条件：" prop="Condition">
          <el-input
            placeholder="请输入报名条件"
            v-model="dataForm.Condition"
            clearable
            maxlength="200"
          ></el-input>
        </el-form-item>
        <el-form-item label="个人费用(元)：" prop="PersonalCost">
          <el-input
            placeholder="请输入个人费用"
            v-model="dataForm.PersonalCost"
            clearable
            maxlength="100"
            style="width: 28%"
          ></el-input>
        </el-form-item>
        <el-form-item label="团体费用(元)：" prop="GroupCost">
          <el-input
            placeholder="请输入团体费用"
            v-model="dataForm.GroupCost"
            clearable
            style="width: 28%"
            maxlength="100"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="最低开班人数：" prop="MinimumPeople">
          <el-input-number
            placeholder="请输入人数"
            v-model="dataForm.MinimumPeople"
            clearable
            :min="1"
            style="width: 28%"
          >
          </el-input-number>
        </el-form-item>
        <el-form-item label="最高开班人数：" prop="MaximumPeople">
          <el-input-number
            placeholder="请输入人数"
            v-model="dataForm.MaximumPeople"
            clearable
            :min="1"
            style="width: 28%"
          >
          </el-input-number>
        </el-form-item> -->
        <el-form-item label="联系电话：" prop="Phone">
          <el-input
            placeholder="请输入培训报名电话"
            v-model="dataForm.Phone"
            clearable
            maxlength="13"
          ></el-input>
        </el-form-item>
        <el-form-item label="图片：" prop="HeadImge">
          <el-upload
            class="upload-demo"
            drag
            action="/api/File/FileUpload"
            multiple
            :on-success="onPicUpdate"
            :on-remove="OnPicRemove"
            :on-preview="onPicPreview"
            :on-exceed="onPicExceed"
            :limit="1"
            :file-list="pictureList"
            accept="image/jpeg, image/gif, image/png, image/jpg"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              支持png/jpg/jpeg格式，建议尺寸650*360
            </div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <div style="height: 77vh; overflow: scroll">
              <img style="width: 100%" :src="dialogImageUrl" alt />
            </div>
          </el-dialog>
        </el-form-item>
        <el-form-item label="上传附件：" prop="File">
          <el-upload
            class="upload-demo"
            drag
            action="/api/File/FileUpload"
            multiple
            :on-success="onFileUpdate"
            :on-remove="OnFileRemove"
            :on-preview="onFilePreview"
            :file-list="fileList"
            accept=".xls, .doc, .ppt, .xlsx, .docx, .pptx, .txt, .pdf, .zip, .rar"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              支持扩展名：.rar .zip .doc .docx .pdf .jpg...
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="视频：" prop="Video" v-if="1==2">
          <el-upload
            class="upload-demo"
            drag
            action="/api/File/FileUpload"
            multiple
            :on-success="onVideoUpdate"
            :on-remove="OnVideoRemove"
            :on-preview="onVideoPreview"
            :on-exceed="onVideoExceed"
            :before-upload="handleBefore"
            :limit="3"
            :file-list="videoList"
            accept="video/*"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              将文件拖到此处，或<em>点击上传</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              <!-- 支持png/jpg/jpeg格式，建议尺寸650*360 -->
            </div>
          </el-upload>
          <el-dialog :visible.sync="showVideo" :append-to-body="true">
            <div style="height: 77vh; overflow: scroll">
              <video style="width: 100%" :src="dialogVideoUrl" controls="controls" />
            </div>
          </el-dialog>
        </el-form-item>

        <el-form-item label="培训介绍：" prop="Abstract">
          <of-tinymce
            ref="editor"
            v-model="dataForm.Abstract"
            :height="500"
            :isEdit="isDisabled"
          ></of-tinymce>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfTinymce from "@/components/controls/of_editor/of_tinymce";
import { saveAs } from "file-saver";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    id: {
      type: String,
      default: "",
    },
    formTitle: {
      type: String,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    //验证截止时间
    var checkDeadLine = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请选择截止时间"));
      }
      //console.log(this.dataForm.StartTimestamp === NaN);
      if (value > this.dataForm.StartTimestamp) {
        return callback(new Error("截止报名时间应小于开始培训时间"));
      }
      callback();
    };
    //验证开始培训时间
    var checkStartTime = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请选择开始培训时间"));
      }
      if (value < this.dataForm.DeadLinestamp) {
        return callback(new Error("开始培训时间应大于截止报名时间"));
      }
      callback();
    };
    //验证结束培训时间
    var checkEndTime = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请选择结束培训时间"));
      }
      if (value < this.dataForm.StartTimestamp) {
        return callback(new Error("结束培训时间应大于开始培训时间"));
      }
      callback();
    };
    //手机号码验证规则
    var checkMobileNo = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("请输入电话号码"));
      }
      if (
        !/^1[0-9]{10}$/.test(value) &&
        !/^(0[0-9]{2,3}\-)([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$/.test(value)
      ) {
        return callback(new Error("无效联系电话"));
      }
      callback();
    };
    //金额校验
    var checkAmount = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error("费用不能为空"));
      }
      if (
        !/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(
          value
        )
      ) {
        return callback(new Error("无效捐款金额，请保留两位小数"));
      }
      callback();
    };
        //金额校验
    var checkAmountTwo = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error("费用不能为空"));
      }
      if (
        !/(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/.test(
          value
        )
      ) {
        return callback(new Error("无效捐款金额，请保留两位小数"));
      }
      callback();
    };
    //人数校验
    var peopleCount = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("人数不能为空"));
      }
      if (!/^[0-9]+$/.test(value)) {
        return callback(new Error("无效人数，请输入整数"));
      }
      callback();
    };
    return {
      //表单规则
      editFormRules: {
        DeadLinestamp: {
          required: true,
          validator: checkDeadLine,
          trigger: "blur",
        },
        StartTimestamp: {
          required: true,
          validator: checkStartTime,
          trigger: "blur",
        },
        EndTimetamp: {
          required: true,
          validator: checkEndTime,
          trigger: "blur",
        },
        Title: [
          { required: true, message: "培训主题不能为空", trigger: "blur" },
        ],
        Address: [{ required: true, message: "地址不能为空", trigger: "blur" }],
        Condition: [
          { required: true, message: "报名条件不能为空", trigger: "blur" },
        ],
        MinimumPeople: [
          { required: true, validator: peopleCount, trigger: "blur" },
        ],
        MaximumPeople: [
          { required: true, validator: peopleCount, trigger: "blur" },
        ],
        PersonalCost: [
          { required: true, validator: checkAmount, trigger: "blur" },
        ],
        GroupCost: [
          { required: true, validator: checkAmountTwo, trigger: "blur" },
        ],
        CostDescription: [
          { required: true, message: "费用成本说明不能为空", trigger: "blur" },
        ],
        Telephone: [
          {
            required: true,
            validator: checkMobileNo,
            trigger: "blur",
          },
        ],
        CoverMap: [
          { required: true, message: "封面图不能为空", trigger: "blur" },
        ],
        Description: [
          { required: true, message: "培训介绍不能为空", trigger: "blur" },
        ],
        StartTime: { required: true, message: "开始培训不能为空", trigger: "blur" },
        DeadLine: { required: true, message: "截止报名时间不能为空", trigger: "blur" },
        EndTime: { required: true, message: "结束培训时间不能为空", trigger: "blur" },
        Phone: {required: true, message: "联系电话不能为空", trigger: "blur"},
        Abstract: {required: true, message: "培训介绍：不能为空", trigger: "blur"}
      },
      isConfirm: false,
      pictureList: [],
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      hideUploadEdit: false, //封面图上传按钮控制
      hideUploadFileEdit: false, //附件上传按钮控制
      width: "60%",
      dataForm: {}, //表单对象
      showVideo: false,
      dialogVideoUrl: "",
      videoList: [],
    };
  },
  mounted() {
    this.loadData();
  },
  components: {
    OfDialog,
    OfTinymce,
  },
  methods: {
    //初始化数据
    loadData() {
      if (this.id) {
        let params = { id: this.id };
        api.QueryTrainById(params).then((res) => {
          if (res.data.Code === 0) {
            this.dataForm = res.data.Data;
            this.dataForm.DeadLine = this.dataForm.DeadLine * 1000;
            this.dataForm.StartTime = this.dataForm.StartTime * 1000;
            this.dataForm.EndTime = this.dataForm.EndTime * 1000;
            this.getImg();
            this.getFile();
            this.getVideo();
          }
        });
      }
    },
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //保存&更新
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          debugger
          if(!this.dataForm.HeadImge || this.dataForm.HeadImge === null || this.dataForm.HeadImge === ''){
            this.$message({
              message: '请上传封面图',
              type: 'warning'
            });
            return
          }
          this.isConfirm = true;
          let params = Object.assign({}, this.dataForm);
          // params.DeadLine = params.DeadLine / 1000;
          // params.StartTime = params.StartTime / 1000;
          // params.EndTime = params.EndTime / 1000;
          params.Status = 0;
          params.Type = 1;
          api
            .SaveTrain(params)
            .then((rep) => {
              this.isConfirm = false;
              if (rep.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: rep.data.Message,
                  type: "error",
                });
              }
            })
            .catch((e) => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error",
              });
            });
        }
      });
    },
    //图片上传
    onPicUpdate(rtnResult) {
      let that = this;
      if (rtnResult.Code == 0) {
        if (!that.dataForm.HeadImge && !that.dataForm.HeadImge) {
          that.dataForm.HeadImge = rtnResult.Data.FileId;
        } else {
          that.dataForm.HeadImge += "," + rtnResult.Data.FileId;
        }
        that.$message({
          message: "附件上传成功",
          type: "success",
        });
      }
    },
    //删除
    OnPicRemove(file, fileList) {
      let that = this;
      that.dataForm.HeadImge = "";
      fileList.forEach((item) => {
        if (that.dataForm.HeadImge == "") {
          that.dataForm.HeadImge = item.response.Data.FileId;
        } else {
          that.dataForm.HeadImge += "," + item.response.Data.FileId;
        }
      });
    },
    //图片查看
    onPicPreview(file) {
      let that = this;
      that.dialogImageUrl =
        "/api/File/Download?Id=" + file.response.Data.FileId;
      that.dialogVisible = true;
    },
    //上传限制
    onPicExceed() {
      let that = this;
      that.$message({
        message: "图片最多只能上传1张",
        type: "error",
      });
    },
    //初始化图片
    getImg() {
      let that = this;
      if (that.dataForm.HeadImge || that.dataForm.HeadImge != null) {
        let params = { Id: that.dataForm.HeadImge };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let fileList = res.data.Data;
            fileList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.pictureList.push({
                url: item.Url,
                name: item.FileName,
                response: response,
              });
            });
          }
        });
      }
    },
    //初始化附件
    getFile() {
      let that = this;
      if (that.dataForm.File || that.dataForm.File != null) {
        this.fileList = JSON.parse(this.dataForm.File);
      }
    },
    //附件上传
    onFileUpdate(rtnResult) {
      let that = this;
      if (rtnResult.Code == 0) {
        const list = {
          name: rtnResult.Data.FullName,
          url: rtnResult.Data.FileId,
        };
        this.fileList.push(list);
        this.dataForm.File = JSON.stringify(this.fileList);
        that.$message({
          message: "附件上传成功",
          type: "success",
        });
      }
    },
    //附件删除
    OnFileRemove(file, fileList) {
      let that = this;
      that.dataForm.File = "";
      that.fileList = [];
    },
    //附件下载
    onFilePreview(file) {
      saveAs("/api/File/Download?Id=" + file.url, file.name);
    },
    onVideoUpdate(rtnResult) {
      let that = this;
      if (rtnResult.Code == 0) {
        if (!that.dataForm.Video && !that.dataForm.Video) {
          that.dataForm.Video = rtnResult.Data.FileId;
        } else {
          that.dataForm.Video += "," + rtnResult.Data.FileId;
        }
        that.$message({
          message: "附件上传成功",
          type: "success",
        });
      }
    },
    OnVideoRemove(file, fileList) {
      let that = this;
      that.dataForm.Video = "";
      fileList.forEach((item) => {
        if (that.dataForm.Video == "") {
          that.dataForm.Video = item.response.Data.FileId;
        } else {
          that.dataForm.Video += "," + item.response.Data.FileId;
        }
      });
    },
    onVideoPreview(file) {
      let that = this;
      that.showVideo = true;
      that.dialogVideoUrl='/Files'+file.storePath;
    },
    onVideoExceed() {
      let that = this;
      that.$message({
        message: "视频最多只能上传3个",
        type: "error",
      });
    },
    handleBefore(file) {
      let uploadStatus = true;
      let size = file.size / 1024 / 1024;
      if (size > 100) {
        this.$message({
          type: "error",
          message: "附件大小必须小于100M",
        });
        uploadStatus = false;
      }
      return uploadStatus;
    },
    //初始化视频
    getVideo() {
      let that = this;
      if (that.dataForm.Video || that.dataForm.Video != null) {
        let params = { Id: that.dataForm.Video };
        api.QueryBigSickApplyFileByIds(params).then((res) => {
          if (res.data.Code == 0) {
            let videoList = res.data.Data;
            videoList.forEach((item) => {
              let response = { Data: { FileId: item.Id } };
              that.videoList.push({
                url: item.Url,
                name: item.FileName,
                storePath: item.StorePath,
                response: response,
              });
            });
          }
        });
      }
    },
  },
};
</script>


<style scoped>
.el-textarea > textarea {
  height: 80px;
}

.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-date-editor >>> .el-input__inner {
  width: 90%;
}
.el-date-editor >>> .el-input__inner {
  width: 90%;
}
.upload-demo >>> .el-upload-dragger {
  width: 270px;
  height: 120px;
}
.upload-demo >>> .el-icon-upload {
  margin: 10px 0 16px;
}
</style>

<style>
.hide {
  display: block !important;
}

.hideFile .el-upload--fileList {
  display: none;
}
</style>
